import { render, staticRenderFns } from "./SDKListKYY.vue?vue&type=template&id=0c1c4ece&scoped=true"
import script from "./SDKListKYY.vue?vue&type=script&lang=js"
export * from "./SDKListKYY.vue?vue&type=script&lang=js"
import style0 from "./SDKListKYY.vue?vue&type=style&index=0&id=0c1c4ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c4ece",
  null
  
)

export default component.exports